class collectionGridItem extends HTMLElement {
    constructor() {
        super();

        this.mainCollection = document.querySelector("[js-hb-main-collection]");
        this.desktopPosition = parseInt(this.dataset.hbPositionDesk);
        this.mobilePosition = parseInt(this.dataset.hbPositionMob);

        this.init();

    };
    init() {
        this.appendGridItem();
    };

    appendGridItem() {
        const targetProductItem = this.mainCollection.querySelector(`[js-product-grid] .grid__item:nth-child(${document.documentElement.clientWidth > 767 ? this.desktopPosition : this.mobilePosition})`);
        
        if(targetProductItem) {
            targetProductItem.insertAdjacentHTML("beforebegin",this.innerHTML)
        }
    };
}
  
customElements.define('collection-grid-item', collectionGridItem);